var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.bannerImage != '')?_c('div',{staticClass:"e-panel:3 l-box:inset2"},[_c('a',{attrs:{"target":"_blank","href":_vm.bannerLink}},[(_vm.bannerImage !== '')?_c('img',{staticClass:"footer",attrs:{"src":_vm.bannerImage}}):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }